import { connect }                         from 'react-redux';
import { onPriceSelect, onSendEmailQuote } from 'pu-redux/actions/QuoteActions';
import Prices                              from '../components/Prices';

const mapStateToProps = state => (
  {
    parameters       : state.get('parameters').toJS(),
    quote            : state.get('quote').toJS(),
    quoteStep        : state.get('quoteStep'),
    parametersChanged: state.get('parametersChanged'),
    suppliers        : state.get('suppliers'),
  }
);

const mapActionsToProps = {
  onPriceSelect,
  onSendEmailQuote,
};

export default connect(mapStateToProps, mapActionsToProps)(Prices);
